/* eslint-disable metabase/no-color-literals */
import type { MetabaseThemeV2 } from "../../types";
import { DARK_THEME_ACCENT_COLORS } from "../accent-colors";
import { getBaseColorsForThemeDefinitionOnly } from "../base-colors";

const baseColors = getBaseColorsForThemeDefinitionOnly();

/**
 * The default dark theme for Metabase.
 */
export const METABASE_DARK_THEME: MetabaseThemeV2 = {
  version: 2,
  chartColors: DARK_THEME_ACCENT_COLORS,
  colors: {
    "admin-navbar": baseColors.octopus[80],
    "admin-navbar-secondary": baseColors.octopus[60],
    "admin-navbar-inverse": baseColors.octopus[60],
    "background-brand": baseColors.brand[90],
    "background-filter": baseColors.filter[90],
    "background-disabled": baseColors.orionAlphaInverse[10],
    "background-disabled-inverse": baseColors.orionAlpha[10],
    "background-error-secondary": baseColors.lobster[90],
    "background-highlight":
      "color-mix(in srgb, var(--mb-color-brand) 7%, transparent)",
    "background-hover":
      "color-mix(in srgb, var(--mb-color-brand) 7%, transparent)",
    "background-selected":
      "color-mix(in srgb, var(--mb-color-brand) 21%, transparent)",
    "background-primary": baseColors.orion[100],
    "background-secondary": baseColors.orion[110],
    "background-tertiary": baseColors.orion[80],
    "background-primary-inverse": baseColors.orion[20],
    "background-secondary-inverse": baseColors.orion[30],
    "background-tertiary-inverse": baseColors.orion[70],
    overlay: baseColors.orionAlpha[70],
    "background-error": baseColors.lobster[90],
    "background-success": baseColors.palm[90],
    brand: baseColors.blue[40],
    "brand-hover": baseColors.brand[30],
    danger: baseColors.lobster[50],
    error: baseColors.lobster[50],
    filter: baseColors.octopus[40],
    focus: baseColors.blue[70],
    "icon-brand": baseColors.brand[40],
    "icon-primary": baseColors.orionAlphaInverse[80],
    "icon-disabled": baseColors.orionAlphaInverse[30],
    "icon-secondary": baseColors.orionAlphaInverse[50],
    "illustration-brand-secondary": baseColors.brand[80],
    "illustration-brand-tertiary": baseColors.brand[90],
    "metabase-brand": baseColors.blue[40],
    "metabase-brand-hover": baseColors.blue[50],
    "saturated-blue": baseColors.ocean[40],
    "saturated-green": baseColors.palm[40],
    "saturated-purple": baseColors.octopus[40],
    "saturated-red": baseColors.lobster[40],
    "saturated-yellow": baseColors.dubloon[30],
    shadow: `color-mix(in srgb, ${baseColors.orion[110]} 20%, transparent)`,
    "success-secondary": baseColors.palm[40],
    success: baseColors.palm[50],
    summarize: baseColors.palm[40],
    "switch-off": baseColors.orionAlphaInverse[20],
    "syntax-parameters-active": baseColors.mango[90],
    "syntax-parameters": baseColors.mango[40],
    "text-brand": baseColors.brand[40],
    "text-filter": baseColors.filter[30],
    "text-tertiary": baseColors.orionAlphaInverse[40],
    "text-tertiary-inverse": baseColors.orionAlpha[40],
    "text-hover": baseColors.brand[30],
    "text-secondary-opaque": baseColors.orion[20],
    "text-primary": baseColors.orionAlphaInverse[80],
    "text-primary-inverse": baseColors.orionAlpha[80],
    "text-secondary": baseColors.orionAlphaInverse[60],
    "text-secondary-inverse": baseColors.orionAlpha[60],
    "text-selected": baseColors.white,
    "tooltip-background-focused": `color-mix(in srgb, ${baseColors.orion[70]} 50%, #000)`,
    "tooltip-background": baseColors.orion[70],
    "tooltip-text-secondary": baseColors.orionAlphaInverse[60],
    "tooltip-text": baseColors.orionAlphaInverse[80],
    warning: baseColors.dubloon[30],
    "background-warning": baseColors.dubloon[90],
    "background-warning-secondary": baseColors.dubloon[70],
    info: baseColors.orion[50],
    "background-info": baseColors.orion[90],
    white: baseColors.orion[110],
    border: baseColors.orionAlphaInverse[20],
    "border-brand": baseColors.brand[80],
    "border-filter": baseColors.filter[80],
    "border-strong": baseColors.orionAlphaInverse[30],
    "border-stronger": baseColors.orionAlphaInverse[50],
    "border-subtle": baseColors.orionAlphaInverse[10],
    copper: "#B87333",
    bronze: "#CD7F32",
    silver: "#C0C0C0",
    gold: "#FFD700",
    "upsell-primary": baseColors.ocean[30],
    "upsell-secondary": baseColors.ocean[80],
    "upsell-gem": "#00d4ff",
  },
};
